export default __webpack_public_path__ + "static/heart3-5dd2279efd4ec6c589544d64950e72cf.webp";